import apiClient from 'src/api/nestready/client'

const getListing = (customerId: string, listingId: string, compact = false) => {
  const client = apiClient(process.env.REACT_APP_NESTREADY_API_URL, customerId)
  const params = compact ? `?compact=${compact}` : ''
  return client.get(`/listings/${listingId}${params}`)
}

const getSimilarListings = (listingId: string) => {
  const client = apiClient(process.env.REACT_APP_NESTREADY_API_URL)

  return client.get(`/listings/${listingId}/similar`)
}

const getEtlStats = (customerId: string) => {
  const client = apiClient(process.env.REACT_APP_NESTREADY_API_URL, customerId)

  return client.get(`/stats/etl`)
}

export { getListing, getSimilarListings, getEtlStats }
